import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogComponent } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { PrivacyDialogComponent } from './components/dialogs/privacy-dialog/privacy-dialog.component';
import { TermsDialogComponent } from './components/dialogs/terms-dialog/terms-dialog.component';
import { ErrorDialogComponent } from './components/dialogs/error-dialog/error-dialog.component';
import { ButtonSpinnerComponent } from './components/spinners/button-spinner/button-spinner.component';
import { AnimationDialogComponent } from './components/dialogs/animation-dialog/animation-dialog.component';
import { LoaderComponent } from './components/loader/loader.component';
import { ChangepasswordDialogComponent } from './components/dialogs/change-password-dialog/change-password-dialog.component';
import { ItemNotFoundComponent } from './components/pages/item-not-found.component';
import { HorizontalSliderComponent } from './components/horizontal-slider/horizontal-slider.component';
import { YesNoDialogComponent } from './components/dialogs/yes-no-dialog/yes-no-dialog.component';
import { VoucherDialogComponent } from './components/dialogs/voucher-dialog/voucher-dialog.component';
import { CountdownTimerComponent } from './components/countdown-timer/countdown-timer.component';
import { PageInfoComponent } from './components/page-info/page-info.component';
@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [
    ConfirmDialogComponent,
    PrivacyDialogComponent,
    TermsDialogComponent,
    ErrorDialogComponent,
    ButtonSpinnerComponent,
    AnimationDialogComponent,
    VoucherDialogComponent,
    LoaderComponent,
    ChangepasswordDialogComponent,
    ItemNotFoundComponent,
    HorizontalSliderComponent,
    YesNoDialogComponent,
    CountdownTimerComponent,
    PageInfoComponent
  ],
  imports: [CommonModule],
  exports: [
    ConfirmDialogComponent,
    PrivacyDialogComponent,
    TermsDialogComponent,
    ErrorDialogComponent,
    ButtonSpinnerComponent,
    AnimationDialogComponent,
    VoucherDialogComponent,
    LoaderComponent,
    ChangepasswordDialogComponent,
    ItemNotFoundComponent,
    HorizontalSliderComponent,
    YesNoDialogComponent,
    CountdownTimerComponent,
    PageInfoComponent
  ]
})
export class SharedModule {}
